import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const hotArticles = articles.filter((a) => a.hot).slice(0, 6);

export default function HotArticles() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 340;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              热门<span className="text-primary-500">爆料</span>
            </h2>
            <p className="text-foreground-500 text-sm mt-2">全网最火爆的吃瓜内容，热度实时更新</p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
            实时更新
          </span>
        </div>

        <div className="relative">
          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-4 scroll-smooth"
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {hotArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="flex-shrink-0 w-[280px] md:w-[320px] bg-background-50 rounded-xl overflow-hidden group cursor-pointer"
                style={{ scrollSnapAlign: 'start' }}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    title={article.title}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium whitespace-nowrap">
                      {article.tags[0]}
                    </span>
                  </div>
                </div>
                <div className="p-4 flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <p className="text-foreground-500 text-xs mb-1.5">
                      {article.tags.slice(0, 2).join(' · ')}
                    </p>
                    <h3 className="text-foreground-950 text-sm font-medium leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                  </div>
                  <div className="flex-shrink-0 text-right">
                    <span className="text-primary-500 text-lg font-bold font-heading whitespace-nowrap">
                      {article.hotIndex}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 bg-background-50 text-foreground-600 cursor-pointer hover:bg-background-100 transition-colors duration-200 hidden md:flex"
            aria-label="向左滚动"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 cursor-pointer hover:bg-foreground-800 transition-colors duration-200 hidden md:flex"
            aria-label="向右滚动"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}